import script from "./OurStorySection.vue?vue&type=script&setup=true&lang=js"
export * from "./OurStorySection.vue?vue&type=script&setup=true&lang=js"

import "./OurStorySection.vue?vue&type=style&index=0&id=1e1a0b1c&scoped=true&lang=css"

import exportComponent from "/Users/tavishi/Desktop/Tilly/code/tern-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e1a0b1c"]])

export default __exports__